import { divisionActions } from '../divisions/division-slice';
import { getData } from '../common-actions';
import { fetchDivisions} from '../../lib/api';

export const getDivisions = (token, signal) => {

  return getData({
    token: token,
    actions: divisionActions,
    fetchFn: (token) => fetchDivisions(token, signal),
    dataKey: "divisions",
    name: "get getDivisions",
    setFunctionName: "setDivisions"
  });
};

